import { logger } from "logging";
import { getCookie } from "./cookie";
import { RANDOM_NUMBER_COOKIE_KEY } from "shared/constants";
import { get } from "logics/src/utils/helpers";
import { getRemoteConfig } from "../index";
import { isServer } from "./isServer";


interface FeatureProps {
  name?: string;
  status: boolean;
  userPercentage: number,
  cookie: string,
}

/**
 * function that compares run with userPercentage in config
 * @param featureData {FeatureProps} - remote configuration object of particular feature
 * @param run {number} - random number
 * @param valueType {string} - type of value to be set in cookie, defaults boolean
 * @returns boolean as default or number if valueType is number
 */
const checkIsEligible = (featureData: FeatureProps, run: number, valueType?: string) => {
  const { status, userPercentage } = featureData || {};
  // checking if value is number
  const isNumber = valueType === "number";
  if (status && (run <= userPercentage)) {
    return isNumber ? 1 : true;
  }
  return isNumber ? 0 : false;
};

/**
 * @description
 * Calculation of experiment by comparing it with randomValue
 * Setting of expreiment eligibility in cookie set in remoteconfig
 * @param key - corresponding feature key that is set in remoteconfig
 * @returns {boolean} - experiment is eligible or not
 */
export const checkIsExperimentEligible = (key: string, valueType?: string) => {
  try {
    if (isServer() || !key) {
      return false;
    }
    const run = Number(getCookie(RANDOM_NUMBER_COOKIE_KEY));
    const remoteConfig = getRemoteConfig();
    const configData = get(remoteConfig?.configs?.AB, key);
    if (configData) {
      const eligibility = checkIsEligible(configData, run, valueType);
      // To Do- cookie set by this line is not used later -- Remove later
      return eligibility;
    }
    // if error fetching key in config
  } catch (error) {
    logger.error(error, `Error in isExperimentEligible for ${key}`);
  }
  return false;
};
